import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { API_KEY } from 'src/constants/apiKey';

import quotation from 'src/repositories/quotation';

type UseEstimateManufacturingNextSizes = {
  handleSuccess: (
    res: AxiosResponse<Response.EstimateManufacturingNextSizesZ0Response, any>,
    args: Payload.ManufacturingSizeDomestic,
  ) => void;
};

const useEstimateManufacturingNextSizesZ0 = ({
  handleSuccess,
}: UseEstimateManufacturingNextSizes) => {
  const getManufacturingNextSizesZ0 = useMutation<
    AxiosResponse<Response.EstimateManufacturingNextSizesZ0Response>,
    AxiosError<Response.Error>,
    Payload.ManufacturingSizeDomestic
  >({
    mutationKey: [API_KEY.ESTIMATE_MANUFACTURING_NEXT_SIZES_Z0],
    mutationFn: (args) => {
      return quotation.getManufacturingSizeDomestic(
        API_KEY.ESTIMATE_MANUFACTURING_NEXT_SIZES_Z0,
        args,
      );
    },
    onSuccess: (res, args) => handleSuccess(res, args),
  });

  return { getManufacturingNextSizesZ0 };
};

export default useEstimateManufacturingNextSizesZ0;
